import { type TypedDocumentNode } from "@apollo/client";
import { type ResultOf, type VariablesOf } from "@/graphql";
import { type Job, type JobType, type UpdateableJobFields } from "@/store/asyncJobs";

interface JobPollingConfig<TDocument = TypedDocumentNode> {
  query: TDocument;
  getQueryVariables: (job: Job) => VariablesOf<TDocument>;
  getJobStatus: (data: ResultOf<TDocument>) => UpdateableJobFields;
}

// Registry of polling configurations by job type
const pollingConfigs = new Map<JobType, JobPollingConfig>();

export const registerPollingConfig = <TDocument>(jobType: JobType, config: JobPollingConfig<TDocument>) => {
  pollingConfigs.set(jobType, config as JobPollingConfig);
};

export const getPollingConfig = <TDocument>(jobType: JobType): JobPollingConfig<TDocument> | undefined => {
  return pollingConfigs.get(jobType) as JobPollingConfig<TDocument> | undefined;
};
